import Network from '@/services/network'

export default function handleHospitalReport() {
    const network = new Network;

    const fetchSalesReportGeneral = (query) => {
        return network.api('get', '/hospital/report/sales-report-general' + query);
    }

    const fetchUserSalesSummary = (query) => {
        return network.api('get', '/hospital/report/user-sales-summary' + query);
    }

    const fetchSalesReportProductWise = (query) => {
        return network.api('get', '/hospital/report/sales-report-product-wise' + query);
    }

    const fetchInvestigationIncentiveReport = (query) => {
        return network.api('get', '/hospital/report/investigation-incentive' + query);
    }

    const iPDPatientStatusReport = (query) => {
        return network.api('get', '/hospital/report/ipd-patient-status' + query);
    }

    const fetchMoneyReceiptStatement = (query) => {
        return network.api('get', '/hospital/report/money-receipt-statement' + query);
    }

    const fetchUserCollectionSummary = (query) => {
        return network.api('get', '/hospital/report/user-collection-summary' + query);
    }

    const fetchIPDSalesCollectionReport = (query) => {
        return network.api('get', '/hospital/report/ipd-sales-collection-report' + query);
    }
    const fetchInvestigationInvoiceReport = (query) => {
        return network.api('get', '/hospital/report/investigation-invoice-report' + query);
    }

    return {
        fetchSalesReportGeneral,
        fetchUserSalesSummary,
        fetchSalesReportProductWise,
        fetchInvestigationIncentiveReport,
        iPDPatientStatusReport,
        fetchMoneyReceiptStatement,
        fetchUserCollectionSummary,
        fetchIPDSalesCollectionReport,
        fetchInvestigationInvoiceReport
    }
}
